import React, { useEffect, useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { Windows } from '../../pages/MainPage';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';
import ConfirmAlert from './ConfirmAlert';

import './HeaderUI.css'

var timer: any = null;

var areGraphicsRendering = false;

const HeaderUI = (props: UIProperties<HeaderUIConfig>) => {
	const [showBackToMainMenu, setShowBackToMainMenu] = useState(false);

	const getSuffix = () => {
		return areGraphicsRendering ? 'waiting for graphics to finish playing' : ''
	}

	const getObjective = () => {
		return 'current objective. ' + (props.parameters.objective ? props.parameters.objective + '. ' + getSuffix() : getSuffix() )
	}

	useEffect(() => {

		if(timer) {
			clearTimeout(timer)
		}
		timer = setInterval(() => {
			var updated = (window as any)['areGraphicsRendering'];
			areGraphicsRendering = updated;
			var el = document.getElementById('main-first-object')

			if(el) {
				el.setAttribute('aria-label', getObjective());
			}
		}, 1000);

	})

	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div>
				<img  style={{
					position: 'absolute',
					top: '-6px'
				}} src="./assets/images/general/header/bar_header_mod.png"/>
				
				<img style={{
					position: 'absolute',
					width: '130px',
					top: '-1px'
				}} src="./assets/images/general/header/CALM_logo.png"/>

				<p className="regular-description-font" style={{
					color: 'rgb(239,243,166)',
					position: 'absolute',
					margin: '0',
					top: '12px',
					left: '140px'
				}} tabIndex={0} id='main-first-object' aria-label={getObjective()}>{props.parameters.objective}</p>
				
				<GeneralButton parameters= {{
					ariaLbl: 'Main menu',
					srcIdle: './assets/images/general/header/bar_mainmenu_main.png',
					srcHighlight: './assets/images/general/header/bar_mainmenu_down.png',
					top: '-3px',
					left: '1654px',
					width: '275px',
					onClicked: () => {
						props.parameters.onMainMenuClicked();
						setShowBackToMainMenu(true);
					}
				}}/>
			</div>

			{showBackToMainMenu ? <ConfirmAlert id={Tools.generateGuid()} key={Tools.generateGuid()} dispatch={null} parameters= {{
				onYes: () => {
					props.parameters.updateWindow(Windows.MainMenu);
				},
				onNo: () => {
					setShowBackToMainMenu(false);
					props.parameters.onMainMenuPromptDismissed();
				},
				text: 'Are you sure you want to quit and return to the main menu?',

			}}></ConfirmAlert>
				 : (null)}
		</div>
	);

};

export interface HeaderUIConfig extends BaseConfig {
	objective: string;
	areGraphicsRendering: boolean;
	updateWindow: (windowToUse: Windows) => void;
	onMainMenuClicked: () => void;
	onMainMenuPromptDismissed: () => void;
}

export default HeaderUI;